import { defineTokens, defineSemanticTokens } from "@pandacss/dev";

export const fonts = defineTokens.fonts({
	poppins: { value: "var(--font-poppins), sans-serif, system-ui" },
	mono: {
		value:
			"ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
	},
});
export const fontWeights = defineTokens.fontWeights({
	light: { value: "300" },
	regular: { value: "400" },
	medium: { value: "500" },
	semibold: { value: "600" },
	bold: { value: "700" },
});

export const semanticFontWeights = defineSemanticTokens.fontWeights({
	button: { value: "{fontWeights.semibold}" },
});

export const fontSizes = defineTokens.fontSizes({
	xxs: { value: "0.625rem" },
	xs: { value: "0.75rem" },
	sm: { value: "0.875rem" },
	md: { value: "1rem" },
	lg: { value: "1.125rem" },
	xl: { value: "1.25rem" },
	"2xl": { value: "1.5rem" },
	"3xl": { value: "2rem" },
});
export const lineHeights = defineTokens.lineHeights({
	xs: { value: "1rem" },
	sm: { value: "1.25rem" },
	md: { value: "1.5rem" },
	lg: { value: "1.75rem" },
	xl: { value: "1.875rem" },
	"2xl": { value: "2rem" },
	"3xl": { value: "2.25rem" },
});
